import education from '../../../assets/education.png'
import scholarship from '../../../assets/scholarship.png'
import teaching from '../../../assets/teaching.png'
import math from '../../../assets/math.png'
import email from '../../../assets/email.png'
import location from '../../../assets/location.png'
import cv from '../../../assets/cv.png'
import orcid from '../../../assets/orcid.png'

function DetailProfile({ onDataChange }) {
    const clickEducation = () => {
      const newNumber = 1;
      onDataChange(newNumber);
    };

    const clickScholarships = () => {
      const newNumber = 2;
      onDataChange(newNumber);
    };

    const clickAssistantships = () => {
      const newNumber = 3;
      onDataChange(newNumber);
    };

    return (
      <>
        <div className='font-noto'>
            <p className='text-3xl mb-3'>Minkyu Kim</p>
            
            <hr/>
            <div className='text-base my-3'>
              <div className="flex">
                <img src={math} className="w-7 h-7 my-auto"></img>
                <p className='my-1 ml-2'>KIAS Junior Fellow, <a href='https://www.kias.re.kr/kias/main/main.do' target='_blank' className="text-sky-600">KIAS</a></p>
              </div>

              <div className="flex">
                <img src={location} className="w-7 h-7 my-auto"></img>
                <p className='my-1 ml-2'><a href='https://www.google.co.kr/maps/place/85+Hoegi-ro,+Dongdaemun-gu,+Seoul/data=!3m1!4b1!4m6!3m5!1s0x357cbb644dcd970d:0x43006ffa568fc0d5!8m2!3d37.5947781!4d127.0474636!16s%2Fg%2F11bz41_3jf?hl=en&entry=ttu' target='_blank' className="text-sky-600">85 Hoegi-ro, Dongdaemun-gu,  Seoul, Republic of Korea</a></p>
              </div>

              <div className="flex">
                <img src={email} className="w-7 h-7 my-auto"></img>
                <p className='my-1 ml-2'>kimminq(at)kias(dot)re(dot)kr</p>
                <a href='https://drive.google.com/file/d/114lq_Jn8XwmVNOkGIKlpRZWaT-w5dpAe/view?usp=drivesdk' target="_blank" className='inline-flex text-sky-600 my-auto'><img src={cv} className="w-6 h-6 my-auto ml-5 mr-2"/>CV</a>
              </div>

              <div className="flex">
                <img src={orcid} className="w-7 h-7 my-auto"></img>
                <p className='my-1 ml-2'><a href='https://orcid.org/orcid-search/search?searchQuery=0000-0002-1124-0638' target='_blank' className="text-sky-600">0000-0002-1124-0638 </a></p>
              </div>

            </div>
            <hr/>
            <div className='text-base mt-3'>
              <p className='my-1 ml-2 indent-4'>Hello, I am Minkyu Kim, a postdoc at Korea Institute for Advanced Study. I grew up in Korea and then studied in Tokyo, Japan, until 2023. Tokyo remains very close to my heart, especially 下北沢 (Shimokitazawa) and 練馬 (Nerima).</p>
              <p className='my-7 ml-2 indent-4'>What I enjoy most about mathematics is looking for structures in mathematical objects and understanding how they are organized. My research interests lie in algebraic topology, homological algebra, and category theory. I currently have a particular interest in functor homology, polynomial functors, and related categorical structures. I originally came to mathematics through applied physics, and this background still influences my interest.</p>
            </div>
            

            {/* <div>
              <p className='text-xl mt-5'>More Information</p>
              
              <div className='flex justify-between my-3 text-base'>
                <div className='h-[30px]'>
                  <button className='inline-flex ml-2 text-sky-600' onClick={clickEducation}><img src={education}/><span className='ml-2'>Education</span></button>
                </div>
                <div className='h-[30px]'>
                  <button className='inline-flex text-sky-600' onClick={clickScholarships}><img src={scholarship}/><span className='ml-2'>Scholarships</span></button>
                </div>
                <div className='h-[30px]'>
                  <button className='inline-flex text-sky-600' onClick={clickAssistantships}><img src={teaching}/><span className='ml-2'>Assistantships</span></button>
                </div>
                <div className='h-[30px]'>
                  <a href='https://drive.google.com/file/d/1V7Sotnlolx5qyvegbWclYWjp7rZDbZr6/view?usp=sharing' target="_blank" className='inline-flex text-sky-600'><img src={cv} className="mr-2"/>CV</a>
                </div>
              </div>
            </div> */}
        </div>
      </>
    );
  }
  
  export default DetailProfile;